"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var React = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var form_with_image_1 = __importDefault(require("~/components/estimate_banners/form_with_image"));
var link_with_image_1 = __importDefault(require("~/components/estimate_banners/link_with_image"));
var small_banner_with_image_1 = __importDefault(require("~/components/estimate_banners/small_banner_with_image"));
var basic_1 = __importDefault(require("~/components/banner/basic"));
var stimulus_2 = require("@hikakaku/shared/util/stimulus");
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.connect = function () {
        var element = this.element;
        var componentName = element.dataset.componentName;
        var props = (0, stimulus_2.parseAttribute)(this, 'props');
        switch (componentName) {
            case 'EstimateBannerFormWithImage':
                react_dom_1.default.render(React.createElement(form_with_image_1.default, __assign({}, props)), element);
                break;
            case 'EstimateBannerLinkWithImage':
                react_dom_1.default.render(React.createElement(link_with_image_1.default, __assign({}, props)), element);
                break;
            case 'EstimateSmallBannerWithImage':
                react_dom_1.default.render(React.createElement(small_banner_with_image_1.default, __assign({}, props)), element);
                break;
            case 'BasicBanner':
                react_dom_1.default.render(React.createElement(basic_1.default, __assign({}, props)), element);
                break;
            default:
                console.warn("EstimateBannerController: Unknown component name: ".concat(componentName));
        }
    };
    return default_1;
}(stimulus_1.Controller));
exports.default = default_1;
